import * as Yup from 'yup'
import { validateURL } from './validators'

const SKETCH_PROFILE_URL_PREFIX = 'sketch.com/profile/'

export const initialValues = {
  shortUrlName: '',
  description: '',
  websiteUrl: '',
  shares: [],
  selectAll: false,
}

export const validationSchema = Yup.object().shape({
  profileUrl: Yup.string()
    .trim()
    .required("URL can't be blank")
    .test('url-validation', 'Invalid URL', function (value) {
      if (!value) return false // URL is required, don't allow empty
      const validationResult = validateURL(
        `https://${SKETCH_PROFILE_URL_PREFIX}${value}`
      )
      return (
        validationResult === 'VALID' || validationResult === 'MISSING_PROTOCOL'
      )
    }),
  description: Yup.string()
    .trim()
    .max(255, 'Description must be 255 characters or less'),
  websiteUrl: Yup.string()
    .trim()
    .test('url-validation', 'Invalid URL', function (value) {
      if (!value) return true // Allow empty URLs
      const validationResult = validateURL(value)
      return (
        validationResult === 'VALID' || validationResult === 'MISSING_PROTOCOL'
      )
    }),
})
